import { createFileRoute } from "@tanstack/react-router";
import { Projects } from "../../features/settings/projects";

export const Route = createFileRoute("/_authed/$org/team/projects")({ component: ProjectsPage });

function ProjectsPage() {
  return <Projects org={Route.useParams().org} />;
}
